var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSli(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 23,
    viewBox: "0 0 24 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.4602 0.0531006C6.12599 0.0531006 0.991211 5.18788 0.991211 11.5221C0.991211 17.8564 6.12599 22.9912 12.4602 22.9912C18.7945 22.9912 23.9293 17.8564 23.9293 11.5221C23.9293 5.18788 18.7945 0.0531006 12.4602 0.0531006ZM9.65271 16.2758H7.33024V8.80182H9.65271V16.2758ZM8.47714 7.88429C7.7436 7.88429 7.26931 7.3646 7.26931 6.72186C7.26931 6.06598 7.75794 5.56182 8.50701 5.56182C9.25608 5.56182 9.71484 6.06598 9.72918 6.72186C9.72918 7.3646 9.25608 7.88429 8.47714 7.88429ZM18.135 16.2758H15.8125V12.1338C15.8125 11.1697 15.4756 10.515 14.6358 10.515C13.9942 10.515 13.6131 10.9582 13.4447 11.3847C13.3825 11.5365 13.367 11.7515 13.367 11.9654V16.2746H11.0433V11.1852C11.0433 10.2522 11.0135 9.47204 10.9824 8.80062H13.0002L13.1066 9.83881H13.1532C13.459 9.35137 14.2081 8.63217 15.4613 8.63217C16.9893 8.63217 18.135 9.65602 18.135 11.8566V16.2758Z",
    fill: "#2B2B2B"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSli);
export default __webpack_public_path__ + "static/media/sli.cfb75544ead1caad04223a2651e607c0.svg";
export { ForwardRef as ReactComponent };